import React from "react";
import { fileUrl } from "@/lib/files";
import { UploadButton, EditableText } from "@/components/fields";
import { Button } from "@/components/ui/button";
import { Download, Trash2, ChevronUp, ChevronDown, FileText } from "lucide-react";
import { TabHeader } from "@/components/royal";

export default function Turns({ player, updatePlayer, editable }) {
  const turns = player.turns || [];

  const addTurn = (res) => updatePlayer((p) => {
    p.turns = p.turns || [];
    p.turns.unshift({
      id: crypto.randomUUID(),
      file_id: res.file_id,
      filename: res.filename,
      label: res.filename.replace(/\.[^.]+$/, ""),
      uploaded_at: new Date().toISOString(),
    });
  });
  const setLabel = (id, v) => updatePlayer((p) => {
    const t = p.turns.find((x) => x.id === id); if (t) t.label = v;
  });
  const remove = (id) => updatePlayer((p) => { p.turns = p.turns.filter((t) => t.id !== id); });
  const move = (idx, dir) => updatePlayer((p) => {
    const j = idx + dir;
    if (j < 0 || j >= p.turns.length) return;
    [p.turns[idx], p.turns[j]] = [p.turns[j], p.turns[idx]];
  });

  return (
    <div className="space-y-6">
      <TabHeader label="Delivery Archive" title="Turns">
        {editable && (
          <UploadButton label="Upload Turn" accept=".pdf,.doc,.docx" onUploaded={addTurn} testId="upload-turn" variant="default" />
        )}
      </TabHeader>

      {turns.length === 0 ? (
        <div className="ht-panel p-12 text-center text-muted-foreground" data-testid="turns-empty">
          No turns delivered yet.
        </div>
      ) : (
        <div className="ht-panel divide-y divide-gold/15" data-testid="turns-list">
          {turns.map((t, idx) => (
            <div key={t.id} data-testid={`turn-row-${idx}`} className="flex items-center gap-4 px-5 py-4">
              <FileText strokeWidth={1.5} className="w-5 h-5 shrink-0 text-muted-foreground" />
              <div className="flex-1 min-w-0">
                {editable ? (
                  <EditableText value={t.label} editable onChange={(v) => setLabel(t.id, v)} testId={`turn-label-${idx}`} />
                ) : (
                  <div className="font-medium truncate">{t.label || t.filename}</div>
                )}
                <div className="text-xs text-muted-foreground truncate">
                  {t.filename} · {t.uploaded_at ? new Date(t.uploaded_at).toLocaleDateString() : ""}
                </div>
              </div>
              <a href={fileUrl(t.file_id, true)} target="_blank" rel="noreferrer" data-testid={`turn-download-${idx}`}>
                <Button variant="outline" size="sm" className="rounded-sm">
                  <Download strokeWidth={1.5} className="w-4 h-4 sm:mr-2" /><span className="hidden sm:inline">Download</span>
                </Button>
              </a>
              {editable && (
                <div className="flex items-center gap-1">
                  <Button variant="ghost" size="icon" className="rounded-sm h-8 w-8" onClick={() => move(idx, -1)} data-testid={`turn-up-${idx}`}>
                    <ChevronUp strokeWidth={1.5} className="w-4 h-4" />
                  </Button>
                  <Button variant="ghost" size="icon" className="rounded-sm h-8 w-8" onClick={() => move(idx, 1)} data-testid={`turn-down-${idx}`}>
                    <ChevronDown strokeWidth={1.5} className="w-4 h-4" />
                  </Button>
                  <Button variant="ghost" size="icon" className="rounded-sm h-8 w-8 text-destructive" onClick={() => remove(t.id)} data-testid={`turn-delete-${idx}`}>
                    <Trash2 strokeWidth={1.5} className="w-4 h-4" />
                  </Button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
